import type { LocationDescriptor } from 'history';

import { RecommendedActivitiesFragment } from '../documents/fragments.generated';

export interface ActivityLink {
    uuid?: string;
    name: string;
    image?: string | null;
    duration?: number | null;
    isCompleted: boolean;
    link: string | LocationDescriptor;
    mediaType?: {
        name: string;
        icon: string;
    };
}

export const mapToContentLink = (
    activity: RecommendedActivitiesFragment,
): ActivityLink | undefined => {
    switch (activity.__typename) {
        case 'ProgramLinkNode':
            return {
                uuid: activity.uuid,
                duration: activity.program.duration,
                image: activity.program.image,
                name: activity.program.name,
                isCompleted: activity.program.isCompleted ?? false,
                link: `/program/${activity.program.slug}`,
                mediaType: {
                    icon: activity.mediaType?.icon ?? '',
                    name: activity.mediaType?.name ?? '',
                },
            };
        case 'MeditationLinkNode':
            return {
                uuid: activity.uuid,
                duration: activity.meditation.duration,
                image: activity.meditation.image,
                name: activity.meditation.name,
                isCompleted: activity.meditation.isCompleted ?? false,
                link: `/meditation/${activity.meditation.slug}`,
                mediaType: {
                    icon: activity.mediaType?.icon ?? '',
                    name: activity.mediaType?.name ?? '',
                },
            };
        case 'InternalLinkNode':
            return {
                uuid: activity.uuid,
                image: activity.image,
                name: activity.title,
                isCompleted: false,
                link: activity.path,
            };
        default:
            return undefined;
    }
};
